<ion-app>
  <div class="{{clicsService.theme}}">
    <ion-router-outlet [animated]="false"></ion-router-outlet>
  </div>
</ion-app>
